/* eslint-disable no-sequences */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-danger */
/* eslint-disable no-bitwise */
import React from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { format } from "date-fns";

import { formatToTimeZone } from "date-fns-timezone";

export { default as STATES } from "./states";
export { default as COUNTRIES } from "./countries";

const isProduction = process.env.NODE_ENV === "production";

export const getDaysDiffBetweenDates = (dateInitial, dateFinal) =>
  (dateFinal - dateInitial) / (1000 * 3600 * 24);

export const getFullName = (first, last) => `${first} ${last}`;
export const isNull = val => val === null;

// eslint-disable-next-line no-bitwise
export const toInt32 = n => n | 0;

export const zeroPad = (value, length) => `${value}`.padStart(length, "0");

export const ourToast = {
  success: message => {
    toast.success(message, { autoClose: 1000, pauseOnHover: false });
  },
  error: message => {
    toast.error(message, { autoClose: 4000 });
  },
  warning: message => {
    toast.warn(message, { autoClose: 4000 });
  }
};

/**
 * DATES
 */

export const calcTimeZone = (date, zone) => {
  const d = new Date(date);
  const timeZone = {
    EST: "America/New_York",
    CST: "America/Chicago",
    MST: "America/Denver",
    PST: "America/Los_Angeles"
  }[zone];

  const newFormat = "MM/DD/YYYY, HH:mm:ss";
  const output = formatToTimeZone(d, newFormat, { timeZone });
  return output;
};

const isObject = object => object != null && typeof object === "object";

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

export const isValidDate = date =>
  date &&
  date instanceof Date &&
  Object.prototype.toString.call(date) === "[object Date]" &&
  !Number.isNaN(date.valueOf());

export const getISODate = (date = new Date(), len = 10, n = 0) =>
  // eslint-disable-next-line no-nested-ternary
  isValidDate(date)
    ? date.toISOString().substr(0, len)
    : n > 0
    ? undefined
    : getISODate(new Date(date), len, n + 1);

const includes = (str, re) => !!str.match(re);

const getTextInputType = ColumnName => {
  const obj = { value: "", parse: x => (isNull(x) ? "" : x) };
  if (includes(ColumnName, /email/gi)) return { ...obj, type: "email" };
  if (includes(ColumnName, /phone/gi)) return { ...obj, type: "tel" };
  if (includes(ColumnName, /note/gi)) return { ...obj, type: "textarea" };

  return { ...obj, type: "text" };
};
export const getInputTypes = ({ ColumnType, ColumnName }) => {
  switch (ColumnType) {
    case "Date":
    case "DateTime":
      return {
        type: "date",
        parse: x => (isNull(x) ? undefined : new Date(x))
      };
    case "Boolean":
      return {
        type: "checkbox",
        parse: x => !!x
      };
    case "Int":
    case "Decimal":
    case "Float":
      return {
        type: "number",
        parse: x => (isNull(x) ? 0.0 : parseFloat(x))
      };

    case "Int32":
      return {
        type: "number",
        parse: x => (isNull(x) ? 0 : toInt32(x))
      };
    case "Integer":
      return {
        type: "number",
        parse: x => (isNull(x) ? 0 : parseInt(x))
      };
    case "String":
      return getTextInputType(ColumnName);
    default:
      console.log(`UNKNOWN TYPE: ${ColumnName}: ${ColumnType}`);
      return getTextInputType(ColumnName);
  }
};

export const flattenObject = (obj, prefix = "") =>
  Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}.` : "";
    if (obj[k] !== null && typeof obj[k] === "object")
      Object.assign(acc, flattenObject(obj[k], pre + k));
    else acc[pre + k] = obj[k];
    return acc;
  }, {});

export const generateCSV = (headers, data) =>
  `${headers.join(",")}\n${data
    .map(d =>
      headers
        .map(h => {
          const value = d[h];
          const formatted =
            typeof value === "number" ? value.toString() : value;
          // this coerces excel to interpret as strings `"=""${d[h]}"""`
          return /^-?\d*\.?\d*$/.test(formatted)
            ? value
            : `"="${JSON.stringify(formatted)}""`;
        })
        .join(",")
    )
    .join("\n")}`;

export const download = (filename, type, content) => {
  const el = document.createElement("a");
  el.setAttribute(
    "href",
    `data:text/${type};charset=utf-8,${encodeURIComponent(content)}`
  );
  el.setAttribute("download", `${filename}`);
  el.style.display = "none";
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};

export const groupBy = (arr, fn) =>
  arr
    .map(typeof fn === "function" ? fn : val => val[fn])
    .reduce((acc, val, i) => {
      acc[val] = (acc[val] || []).concat(arr[i]);
      return acc;
    }, {});

export const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export const getType = v =>
  // eslint-disable-next-line no-nested-ternary
  v === undefined
    ? "undefined"
    : v === null
    ? "null"
    : v.constructor.name.toLowerCase();

export const capitalizeEveryWord = str =>
  str.replace(/\b[a-z]/g, char => char.toUpperCase());

export const fromCamelCase = (str, separator = "_") =>
  str
    .replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`)
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${separator}$2`)
    .toLowerCase();

export const mapValues = (obj, fn) =>
  Object.keys(obj).reduce((acc, k) => {
    acc[k] = fn(obj[k], k, obj);
    return acc;
  }, {});

export const parseQueryResultWithColumns = (x, columns) => {
  const obj = flattenObject(x);
  return columns.reduce((acc, curr) => {
    if (
      obj[`${curr.accessor}`] === null ||
      (typeof obj[`${curr.accessor}`] === "undefined" &&
        typeof curr.Cell !== "function") ||
      (typeof obj[`${curr.accessor}`] === "string" &&
        !obj[`${curr.accessor}`].length)
    ) {
      acc[curr.Header] = "";
    } else if (curr.Cell) {
      const result = curr.Cell({
        row: { original: x },
        cell: {
          value: obj[`${curr.accessor}`] || x[`${curr.accessor}`],
          row: { original: x }
        }
      });

      acc[curr.Header] =
        // if Cell fn returns a react element
        result && typeof result.type === "function"
          ? result.props.value
          : result;
    } else if (
      typeof obj[`${curr.accessor}`] === "string" &&
      obj[`${curr.accessor}`].includes(",")
    ) {
      acc[curr.Header] = String(obj[`${curr.accessor}`]).replace(/"/gi, "''"); // .replace(/,/gi, " ");
    } else {
      acc[curr.Header] = obj[`${curr.accessor}`];
    }
    return acc;
  }, {});
};

export const downloadCSV = async (
  client,
  { query, where, orderByMulti },
  dataName,
  columns
) => {
  const { data } = await client.query({
    query,
    variables: {
      where,
      orderByMulti
    },
    fetchPolicy: "network-only"
  });

  const items = data[dataName].Payload || data[dataName];
  const result =
    items && items.map(x => parseQueryResultWithColumns(x, columns));

  if (result && result[0]) {
    const CSV = generateCSV(Object.keys(result[0]), result);
    return download(`${dataName}.csv`, "csv", CSV);
  }
  toast.error("No Data to Export");
};

// This function will duplicate prepend an object to each object in an array
export const prependMerge = (head, arr) =>
  arr.map(row => ({ ...head, ...row }));

// array of queries in this format
/**
 *     {
 *      query,
 *      where,
 *      dataName,
 *      columns
 *      }
 */
export const prependMergeDownloadCSV = async (client, headQuery, tailQuery) => {
  try {
    const headResult = parseQueryResultWithColumns(
      (
        await client.query({
          query: headQuery.query,
          variables: { where: headQuery.where }
        })
      ).data[headQuery.dataName],
      headQuery.columns
    );

    const tailResult = (
      await client.query({
        query: tailQuery.query,
        variables: { where: tailQuery.where }
      })
    ).data[tailQuery.dataName].map(x =>
      parseQueryResultWithColumns(x, tailQuery.columns)
    );
    const result = await tailResult.map(row => ({ ...headResult, ...row }));
    const CSV = await generateCSV(Object.keys(result[0]), result);
    return download(`${tailQuery.dataName}.csv`, "csv", CSV);
  } catch (err) {
    toast.error("Error building Report.");
  }
};

export const exportCSV = (name, columns, rows) => {
  const data = generateCSV(columns, rows);
  return download(`${name}.csv`, "csv", data);
};

export const isNumber = val => typeof val === "number";

export const average = (...nums) =>
  nums.reduce((acc, val) => acc + val, 0) / nums.length;
export const mean = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
export const standardDeviation = (arr, usePopulation = false) => {
  const avg = mean(arr);
  return Math.sqrt(
    arr
      .reduce((acc, val) => acc.concat((val - avg) ** 2), [])
      .reduce((acc, val) => acc + val, 0) /
      (arr.length - (usePopulation ? 0 : 1))
  );
};

export const toCurrency = (n, curr, LanguageFormat = undefined) =>
  Intl.NumberFormat(LanguageFormat, {
    style: "currency",
    currency: curr
  }).format(n);

export const createMarkup = html => (
  // eslint-disable-next-line react/no-danger
  <div
    dangerouslySetInnerHTML={{ __html: `<pre>${html}</pre>` }}
    style={{ whiteSpace: "normal" }}
  />
);

export const getTagColorByOrderStatus = color => {
  const TAG_COLORS = {
    UNASSIGNED: "primary",
    SCHEDULED: "warning",
    "IN PROCESS": "info",
    CANCELLED: "danger",
    COMPLETED: "success",
    "APPROVED FOR INVOICING": "link",
    "EXPORTED TO ACCOUNTING": "dark",
    VOIDED: "danger"
  };
  return TAG_COLORS[color.toUpperCase()];
};

export const uuidGenerator = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );

export const capitalize = ([first, ...rest], lowerRest = false) =>
  first.toUpperCase() +
  (lowerRest ? rest.join("").toLowerCase() : rest.join(""));

// this is used in a number of components
// copy & paste or import
export const makeHandleChange = (inputs, setInputs) => e => {
  const value =
    e.target.type === "checkbox" ? e.target.checked : e.target.value;
  setInputs({ ...inputs, [e.target.name]: value });
};

/**
 * FILTERS
 */
const STORAGE_KEYS = [
  "BOOKING_CODE",
  "CUSTOMER",
  "DIRECTION",
  "LOCATION",
  "ORDER",
  "PRODUCT",
  "ROUTE",
  "TARIFF",
  "CERTIFICATION",
  "COMPANY",
  "EMPLOYEE",
  "ACCOUNT",
  "USER_GROUP",
  "USER",
  "VENDOR",
  "ITEM",
  "ITEMCATEGORY"
];

export const getFilterState = (key, defaults) =>
  window.localStorage.getItem(key)
    ? JSON.parse(window.localStorage.getItem(key))
    : { ...defaults };

export const saveFilterState = (key, filters = {}) =>
  window.localStorage.setItem(key, JSON.stringify(filters));

export const clearFilterState = (keys = STORAGE_KEYS) =>
  keys.forEach(key => window.localStorage.removeItem(`${key}_FILTERS`));

export const curry = (fn, arity = fn.length, ...args) =>
  arity <= args.length ? fn(...args) : curry.bind(null, fn, arity, ...args);

export const round = (value, step = 1.0) => {
  const f = 1 / step;
  return Math.round(value * f) / f;
};

export const initializeArrayWithRange = (end, start = 0, step = 1) =>
  Array.from(
    { length: Math.ceil((end - start + 1) / step) },
    (v, i) => i * step + start
  );

export const orderBy = (arr, props, orders) =>
  [...arr].sort((a, b) =>
    props.reduce((acc, prop, i) => {
      if (acc === 0) {
        const [p1, p2] =
          orders && orders[i] === "desc"
            ? [b[prop], a[prop]]
            : [a[prop], b[prop]];
        acc = p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
      }
      return acc;
    }, 0)
  );

export const deepFlatten = arr =>
  [].concat(...arr.map(v => (Array.isArray(v) ? deepFlatten(v) : v)));

export const formatCurrency = n => {
  if (n) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(n);
  }
  return "$0.00";
};

export const compose = (...fns) =>
  fns.reduce(
    (f, g) => (...args) => f(g(...args)),
    arg => arg
  );

export const sum = (...arr) => [...arr].reduce((acc, val) => acc + val, 0);

export const unmaskCurrency = (maskedValue = "") =>
  parseFloat(maskedValue.replace(/\D/g, "") || 0, 10) / 100;

export const getUTCFormattedDate = date =>
  date
    ? new Date(date).setUTCHours(13, 0, 0)
    : new Date().setUTCHours(13, 0, 0);

export const randomHexString = (len = 4) =>
  [...Array(len)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join("");

export const generateInvoiceBatchNumber = async () => {
  const str = await randomHexString(2);
  return `INV${moment().format("YYYYMMDD")}_${str.toUpperCase()}`;
};

export const runPromisesInSeries = ps =>
  ps.reduce((p, next) => p.then(next), Promise.resolve());

export const getDifferenceByTimeZone = (data, date, kind, other) => {
  const dateFormatted = data
    ? calcTimeZone(
        date,
        kind === "Pickup"
          ? data.PickupLocation.TimeZone.CodeId
          : data.DeliveryLocation.TimeZone.CodeId
      )
    : calcTimeZone(date, other);

  return parseInt(
    Math.abs(new Date(date) - new Date(dateFormatted)) / 36e5,
    10
  );
};

export const getBooleanValue = field => (field ? "True" : "False");

export const getDateValue = date =>
  date && format(new Date(date), "MM/dd/yyyy");

export const getCustomerValue = Customer =>
  Customer
    ? `${Customer.CustomerNo}${Customer.Name ? ` - ${Customer.Name}` : ""}${
        Customer.City && Customer.State
          ? ` - ${Customer.City}, ${Customer.State}`
          : ""
      }`
    : "";

export const convertTimeZoneDataBase = date => {
  const localDate = new Date(date);
  localDate.setTime(
    localDate.getTime() - localDate.getTimezoneOffset() * 60 * 1000
  );
  return localDate;
};

export const getValueFromObject = (from, selector) =>
  selector
    .replace(/\[([^[\]]*)\]/g, ".$1.")
    .split(".")
    .filter(t => t !== "")
    .reduce((prev, cur) => prev && prev[cur], from);

export const equals = (a, b) => {
  if (a === b) return true;

  if (a instanceof Date && b instanceof Date)
    return a.getTime() === b.getTime();

  if (!a || !b || (typeof a !== "object" && typeof b !== "object"))
    return a === b;

  if (a.prototype !== b.prototype) return false;

  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;

  return keys.every(k => equals(a[k], b[k]));
};

export const uniqueElementsBy = (arr, fn) =>
  arr.reduce((acc, v) => {
    if (!acc.some(x => fn(v, x))) acc.push(v);
    return acc;
  }, []);

export const omit = (obj, arr) =>
  Object.keys(obj)
    .filter(k => !arr.includes(k))
    .reduce((acc, key) => ((acc[key] = obj[key]), acc), {});

export default omit;

export const getS3ImageUrl = value => {
  const [objectKey] = value?.split("/").reverse() || "";
  return [
    isProduction ? "/api" : "http://localhost:4000",
    "/transgas-uploads/",
    objectKey
  ]
    .filter(Boolean)
    .join("");
};
